import React, { Component } from 'react';
import {
    dragEffect,
    setMidiEffectDragging,
    setPulledEffects,
    setInstrumentTypeDragging,
    setPresetDragging,
    setSampleDragging,
    setSampleTagDragging,
} from 'actions/index.js';
import SidebarPresets from './SidebarPresets.js';
import TracksOverview from './TracksOverview.js';
import Sequences from 'components/sequences2/Sequences.js';
import TrackQuickView from './TrackQuickView.js';
import QuickSampleChooser from './QuickSampleChooser.js';
import OptionTabs from 'components/sounds/OptionTabs.js';
import Selector from 'components/selector2/Selector.js';
import PresetModal from 'components/presets/PresetModal.js';
import Sticky from 'react-sticky-el';
import PaletteComponent from 'components/palette/PaletteComponent.js';
import InstrumentsView from 'components/instruments/InstrumentsView.js';
import SequencesComponent from 'components/sequences/SequencesComponent.js';
import Presets from 'components/selector2/presets/Presets.js';
import { SEQUENCER_VIEW, MIX_VIEW } from "constants/view-modes.js";
import { connect } from "react-redux";
import { Button,
         ButtonDropdown,
         DropdownToggle,
         DropdownMenu,
         DropdownItem } from 'reactstrap';
import ConditionedComponent from 'components/ConditionedComponent.js';
import NotesComponent from 'components/notes/NotesComponent.js';
import Keyboard from 'components/midi/Keyboard.js';
import MidiPads from 'components/midi/MidiPads.js';
import ContextualHelpComponent from './ContextualHelpComponent.js';
import {setSampleAuditioning} from 'actions/index.js';
import {setContextualHelp} from 'actions/index.js';
import FoldersComponent from 'components/folders/FoldersComponent.js';
import {setSamplePack} from 'actions/index.js';
import {setSelectorMode} from 'actions/index.js';
import {addSamplePack} from 'actions/index.js';
import {
    ADD_ALL_SOUNDS_BUTTON,
    PRESET_FOLDERS} from 'constants/contextual-help';
import ethereum from 'decentralized/ethereum.js';
import {
    setSidebarViewMode,
    setSidebarCollapsed} from 'actions/index.js';
import PacksComponent from 'components/packs/PacksComponent.js';
import {
    SOUNDS,
    PACKS,
    EXTERNAL,
    SEQUENCES,
    PRESETS,
    INSTRUMENTS,
    NOTES} from 'constants/sidebar-view-modes.js';
import '../../Sidebar.scss';
const presets = ethereum.presets;

window.topOffset = 0;
window.bottomOffset = -400;

class SidebarComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dropdownOpen: false,
            showPresetModal: false,
        }

        this.onClosePresetModal = this.onClosePresetModal.bind(this);
        this.loadWithLFOs = this.loadWithLFOs.bind(this);
        this.loadWithoutLFOs = this.loadWithoutLFOs.bind(this);
    }

    get showMidiPads() {
        if (this.props.padMappings === undefined) {
            return false;
        }

        let x = Object.keys(this.props.padMappings)
            .length > 0;

        return x;
    }

    onDrop() {
        let state = this.props.sequencerEngine.state;
        let effectDragging = state.sequencer.effectDragging ||
            state.effects.midiEffectDragging;
        if (effectDragging) {
            let pulledEffects = [...state.effects.pulledEffects, effectDragging.effect];
            this.props.setPulledEffects(pulledEffects);
            // in this case we need to move the effect to the outside of the
            // track so that it is seen always
            this.props.setMidiEffectDragging(undefined);
            this.props.setEffectDragging(undefined);
        }
        this.props.setPresetDragging(undefined);
        this.props.setSampleDragging(undefined);
        this.props.setInstrumentTypeDragging(undefined);
        this.props.setSampleTagDragging(undefined);
    }

    toggleDropdown() {
        this.setState({dropdownOpen: !this.state.dropdownOpen});
    }

    get sequencerEngine() {
        return this.props.sequencerEngine;
    }

    // called when user chooses a sound they wish to add, this
    // function adds the sound to the sequencer in a new track
    async addSound(sample, layerMode, slice, chordSample, chord) {
       let newCursor = this.sequencerEngine.tracks.length;
       if (layerMode && this.sequencerEngine.tracks.length > 0) {
            var selectedTrack = this.sequencerEngine.cursor.track == null ?
                0 : this.sequencerEngine.cursor.track;
            this.sequencerEngine.addSound(sample, selectedTrack, undefined, chord);
        } else {
            this.sequencerEngine.addSound(sample, undefined, slice, chord);
        }
    }

    auditionSound(sample) {
        var selectedTrack = this.sequencerEngine.cursor.track == null ?
            0 : this.sequencerEngine.cursor.track;

        this.sequencerEngine.auditionSound(sample, selectedTrack);
        this.props.setSampleAuditioning(sample);
    }

    // triggered when user clicks "Add some sounds" button, which
    // opens up the Sound Selector Mode
    showSoundsSelectorView() {
        this.props.setSelectorMode(true);
        this.props.setSidebarViewMode(SOUNDS);
    }

    isShowingSoundsPane() {
        if (this.props.sidebarCollapsed) {
            return false;
        }
        return this.props.showSelectorMode ||
            this.props.sidebarViewMode !== SOUNDS;
    }

    showSequences() {
        this.props.setSidebarViewMode(SEQUENCES);
    }

    showExternal() {
        this.props.setSidebarViewMode(EXTERNAL);
    }

    showPresets() {
        this.props.setSidebarViewMode(PRESETS);
    }

    onClickInstrumentsButton() {
        this.props.setSidebarViewMode(INSTRUMENTS);
    }

    onClickAddAudioTrackButton() {
        // add a midi track to 
        this.sequencerEngine.addAudioTrack();
        this.setState(this.state);
    }

    toggleCollapse() {
        this.props.setSidebarCollapsed(!this.props.sidebarCollapsed);
    }

    onChooseItem(preset) {
        this.setState({showPresetModal: true, presetToLoad: preset});
    }

    onChooseFolder(folder) {
        this.setState({showPresetModal: true, folderToLoad: folder});
    }

    onClosePresetModal() {
        this.setState({showPresetModal: false});
    }

    loadWithLFOs() {
        this.setState({showPresetModal: false});
        if (this.state.presetToLoad) {
            this.props.sequencerEngine.loadPreset(
                this.state.presetToLoad, true);
        } else {
            this.state.folderToLoad.getAllItems().forEach(
                item =>
                    this.props.sequencerEngine.loadPreset(
                        item, true));
        }
    }

    loadWithoutLFOs() {
        this.setState({showPresetModal: false});
        
        if (this.state.presetToLoad) {
            this.props.sequencerEngine.loadPreset(
                this.state.presetToLoad, false);
        } else {
            this.state.folderToLoad.getAllItems().forEach(
                item =>
                    this.props.sequencerEngine.loadPreset(
                        item, false));
        }
    }

    get selectedEffect() {
        let state = this.props.sequencerEngine.store.getState();
        if (state.effects.selectedEffect === undefined) {
            return undefined;
        }

        return this.props.sequencerEngine.selectedEffect;
    }

    get cursor() {
        return this.props.sequencerEngine.cursor;
    }

    get selectedTrack() {
        return this.props.sequencerEngine.tracks[this.cursor.track];
    }

    render() {
        let hideSequencer = this.props.viewMode !== SEQUENCER_VIEW &&
            this.props.viewMode !== MIX_VIEW;

        let soundsSelectorComponent = '';
        if (this.props.sidebarViewMode === SOUNDS && this.props.showSelectorMode) { 
            soundsSelectorComponent = (
                <Selector
                  ethereumSearcher={this.props.ethereumSearcher}
                  sequencerEngine={this.sequencerEngine}
                  onAudition={(sample) => this.auditionSound(sample)}
                  onAddSound={(sample, layerMode, slice, chordSample, chord) => this.addSound(sample, layerMode, slice, chordSample, chord)}/>
            );
        }


        if (this.props.sidebarViewMode === PACKS) {
            soundsSelectorComponent = (
                <PacksComponent sequencerEngine={this.sequencerEngine}/>
            );
        }

        let instrumentsComponent = '';
        if (this.props.sidebarViewMode === INSTRUMENTS) {
            instrumentsComponent =
                <InstrumentsView sequencerEngine={this.sequencerEngine}/>;
        }

        let sequencesComponent = '';
        if (this.props.sidebarViewMode === SEQUENCES) {
            sequencesComponent =
                <Sequences sequencerEngine={this.sequencerEngine}/>;
        }

        let presetsComponent = '';
        if (this.props.sidebarViewMode === PRESETS) {
            presetsComponent =
                <Presets sequencerEngine={this.sequencerEngine}/>
        }

        let notesComponent = '';
        if (this.props.sidebarViewMode === NOTES) {
            notesComponent =
                <NotesComponent sequencerEngine={this.sequencerEngine}/>
        }
        let trackHeight = 400;
        let remainingHeights = 300;
        let trackNumberStickinessThreshold =
            Math.ceil((window.innerHeight - remainingHeights) / trackHeight);
        const WINDOW_HEIGHT_THRESHOLD = 1001;
        let disableStickiness = 
            false;

        let topOffset = this.isShowingSoundsPane() ? window.topOffset : -500;
        let bottomOffset = this.isShowingSoundsPane() ? window.bottomOffset: -100;

        if (this.props.hidePresets) {
            topOffset = 300;
            bottomOffset = -400;
        }

        let stickyKeyboardClass = this.props.zIndexHack ?
            'z-index-hack' : ' inner-sidebar';

        let sidebarClassName = this.props.sidebarCollapsed ?
            "sounds-pane collapsed" :
            this.isShowingSoundsPane() ? "sounds-pane" : "hide sounds-pane";

        if (this.isShowingSoundsPane() && this.props.hidePresets && this.props.viewMode === SEQUENCER_VIEW) {
            disableStickiness = true;
        }
        if (this.props.showPianoRoll) {
            disableStickiness = true;
        }
        if (this.props.disableStickiness) {
            disableStickiness = true;
        }

        let style = {
            height: window.innerHeight - 147
        };


        if (this.props.showPianoRoll) {
            style.height -= this.props.bottomHeight - 80;
            bottomOffset = 230;
        }

        if (this.props.viewMode === MIX_VIEW) {
            style.height = window.innerHeight - 65;
        }
        let defaultView = (
            <div
              style={{
                  ... style,
                  height: style.height - 20
              }}
              className="sidebar-content">
               {instrumentsComponent}
               {presetsComponent}
               {sequencesComponent}
               {soundsSelectorComponent}
               {notesComponent}
              <ConditionedComponent condition={!this.isShowingSoundsPane()}>
                <OptionTabs/>
                <QuickSampleChooser sequencerEngine={this.sequencerEngine}/>
                <div className="overviews">
                  <div className="overview-left">
                    {!this.props.explorerMaximized && (!this.props.searchText || this.props.searchText === "") ? 
                     <TrackQuickView
                       installation={this.props.hidePresets}
                       sequencerEngine={this.sequencerEngine}
                     />  : ''}
                    <SidebarPresets sequencerEngine={this.sequencerEngine}/>
                  </div>
                  {!this.props.explorerMaximized && (!this.props.searchText || this.props.searchText === "") ? 
                   <TracksOverview sequencerEngine={this.sequencerEngine}/>
                   : ''}
                </div>
                 <PresetModal
                   ethereum={ethereum}
                   presets={presets}
                   preset={this.state.presetToLoad}
                   show={this.state.showPresetModal}
                   onClose={this.onClosePresetModal}
                   onClickYes={this.loadWithLFOs}
                   onClickNo={this.loadWithoutLFOs}/>
              </ConditionedComponent>
            </div>
        );

        /**
                 <ConditionedComponent condition={!this.props.hidePresets}>
                 <div
                  onMouseOver={() => this.props.setContextualHelp(PRESET_FOLDERS)}
                  onMouseLeave={() => this.props.setContextualHelp(undefined)}
                   className="preset-folders">
                   <FoldersComponent
                     sequencerEngine={this.props.sequencerEngine}
                     onTestItem={(preset) => []}
                     onChooseFolder={(folder) => this.onChooseFolder(folder)}
                     onChooseItem={(item) => this.onChooseItem(item)}
                     showItems={true}/>
                 </div>
                 </ConditionedComponent>
*/

        let soundPane = (
            <div onDrop={() =>this.onDrop()} className="sidebar-container no-select">
              <div style={style} className={sidebarClassName}>
              <div className="sidebar-header">
                <div
                  onClick={() => this.toggleCollapse()}
                  className="collapse-toggle">
                  {this.props.sidebarCollapsed ? 
                      <div className="arrow-down"/> :
                      <div className="arrow-right"/>}
                </div>
             </div>
             <ConditionedComponent condition={!this.props.sidebarCollapsed}>
               <ConditionedComponent condition={this.isShowingSoundsPane()}>
                 <div className="sound-toolbar">
                   <OptionTabs/>
                 </div>
               </ConditionedComponent>
               {defaultView}
             </ConditionedComponent>
            </div>
            </div>);

        if (hideSequencer) {
            return '';
        } else {
            let holderId =
                this.props.sidebarCollapsed ? 'sidebar-holder-collapsed' :
                this.isShowingSoundsPane() ? 'sidebar-holder-selector' :
                'sidebar-holder';
            return (
                <Sticky
                  className={stickyKeyboardClass}
                  stickyClassName={"sticky-keyboard " + stickyKeyboardClass}
                  holderProps={{id: holderId}}
                  disabled={disableStickiness}
                  mode="top"
                  positionRecheckInterval={20}
                  boundaryElement={".scroll-area"} //this.props.showPianoRoll ? ".scroll-area" : ".main-area"}
                  hideOnBoundaryHit={false}
                  topOffset={topOffset}
                  bottomOffset={bottomOffset}>
                  {soundPane}
                </Sticky>
            );
        }
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSamplePack : samplePack => dispatch(setSamplePack(samplePack)),
        addSamplePack : samplePack => dispatch(addSamplePack(samplePack)),
        setSelectorMode: m => dispatch(setSelectorMode(m)),
        setSidebarViewMode: m => dispatch(setSidebarViewMode(m)),
        setSidebarCollapsed: m => dispatch(setSidebarCollapsed(m)),
        setSampleAuditioning: s => dispatch(setSampleAuditioning(s)),
        setContextualHelp: s => dispatch(setContextualHelp(s)),
        setInstrumentTypeDragging: m => dispatch(setInstrumentTypeDragging(m)),
        setPresetDragging: m => dispatch(setPresetDragging(m)),
        setSampleDragging: m => dispatch(setSampleDragging(m)),
        setSampleTagDragging: m => dispatch(setSampleTagDragging(m)),
        setPulledEffects: e => dispatch(setPulledEffects(e)),
        setEffectDragging: fx => dispatch(dragEffect(fx)),
        setMidiEffectDragging: fx => dispatch(setMidiEffectDragging(fx))
    };
};

const mapStateToProps = (state, props) => {
    return {
        viewMode: state.sequencer.viewMode,
        showSelectorMode: state.sequencer.showSelectorMode,
        sidebarCollapsed: state.selector.sidebarCollapsed,
        sidebarViewMode: state.sequencer.sidebarViewMode,
        isTrackFocused: state.sequencer.trackFocused !== undefined,
        showPresets: state.sequencer.showPresets,
        zIndexHack: state.sequencer.zIndexHack,
        selectedTrack: state.mix.selectedTrack,
        padMappings: state.keyboard.padMappings,
        showPianoRoll: state.sequencer.showPianoRoll,
        selectedEffect: state.effects.selectedEffect,
        isShowingEffects: state.tracks.showTrackEffects[state.mix.selectedTrack],
        isMacroMapping: state.effects.isMacroMapping,
        bottomHeight: state.arrangement.bottomHeight,
        searchText: state.selector.quickAddSearchText,
        explorerMaximized: state.selector.explorerMaximized
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(SidebarComponent);
